import {Injectable} from '@angular/core';

/**
 * This is only to pass the email address to the thank you page.
 */
@Injectable()
export class DataStoreService {

  public email: string;
  public lang: string;

}
